var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-input-group",
        [
          _c("b-form-input", {
            attrs: {
              id: "input_location",
              size: "sm",
              state: _vm.state,
              disabled: _vm.isDisabled,
              placeholder: "Выберите объект",
              autocomplete: "off"
            },
            on: { focus: _vm.onFocusIn, blur: _vm.onFocusOut },
            model: {
              value: _vm.query,
              callback: function($$v) {
                _vm.query = $$v
              },
              expression: "query"
            }
          }),
          _vm._v(" "),
          _c(
            "b-input-group-append",
            [
              _vm._t(
                "append-btn",
                function() {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          size: "sm",
                          disabled: !_vm.query || _vm.isDisabled
                        },
                        on: { click: _vm.onClear }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "times-circle" }
                        })
                      ],
                      1
                    )
                  ]
                },
                {
                  onClear: _vm.onClear,
                  query: _vm.query,
                  disabled: _vm.isDisabled
                }
              )
            ],
            2
          ),
          _vm._v(" "),
          _vm.isFocus
            ? _c(
                "b-list-group",
                {
                  staticClass: "autocomplete-input-location",
                  class: { dropUp: _vm.dropUp }
                },
                [
                  _vm._l(_vm.filteredItems, function(item, index) {
                    return _c(
                      "b-list-group-item",
                      {
                        key: index,
                        attrs: { button: "" },
                        on: {
                          mousedown: function($event) {
                            return _vm.onClick(item)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "text-small" }, [
                          _vm._v(_vm._s(item.name))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-secondary text-small" },
                          [
                            _vm._v(
                              "Заказчик: " +
                                _vm._s(item.customer_name) +
                                " | Город: " +
                                _vm._s(item.town_name) +
                                " |"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        item.address
                          ? _c(
                              "div",
                              { staticClass: "text-secondary text-small" },
                              [_vm._v("Адрес: " + _vm._s(item.address))]
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.filteredItems.length === 0 && _vm.query
                    ? _c("b-list-group-item", { attrs: { disabled: "" } }, [
                        _c("small", [_vm._v("Ничего не найдено")])
                      ])
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17c61332", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c61332","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/LocationSelect.vue
// module id = null
// module chunks = 